import React, { useContext } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import AppContext from "../../AppContext";
import Tickets from "../../components/Support/Tickets";
import View from "../../components/Support/Tickets/View";

const TicketView = () => {
  const { id } = useParams();
  return <View id={id} />;
};

const TicketsPage = () => {
  const { user } = useContext(AppContext);
  const navigate = useNavigate();

  const handleOpenTicket = (ticketId) => {
    navigate(ticketId);
  };

  return (
    <Routes>
      <Route path="" element={<Tickets onTicketSelect={handleOpenTicket} />} />
      <Route path=":id" element={<TicketView />} />
    </Routes>
  );
};

TicketsPage.propTypes = {};

export default TicketsPage;
